<div class="print-modal">
  <h4>
    <mat-icon>print</mat-icon>
    Preparing data for print
    <span class="spinner"></span>
  </h4>
</div>
<div class="modal-footer">
</div>


